export default __webpack_public_path__ + "static/media/QR.0b8feb64.jpg";